import React from 'react';

const ConfirmationCta = ({ copy, button = {}, copyClass = '' }) => {
  const { component: ButtonComponent, props: buttonProps } = button;
  return (
    <>
      {copy && <p className={`copy ${copyClass}`}>{copy}</p>}
      {ButtonComponent && <ButtonComponent {...buttonProps} />}
    </>
  );
};

export default ConfirmationCta;
